module.exports = __webpack_public_path__ + "static/img/aboutUs10.89e5830.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs10.jpg
// module id = 1362
// module chunks = 1